import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Toaster } from 'react-hot-toast';
import { TourOverlay } from '@/components/tours/TourOverlay';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="flex h-screen overflow-x-hidden bg-background">
      <Sidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Header />
        <main
          className="scrollbar-hide min-h-0 flex-1 overflow-y-auto bg-muted/20"
          id="dashboard-main"
        >
          <div className="dashboard-main-content flex min-h-0 min-w-0 flex-1 flex-col gap-6 px-4 pt-6">
            {children}
          </div>
        </main>
        <Toaster position="top-right" />
      </div>
      <TourOverlay />
    </div>
  );
}
